import axios, { AxiosError } from "axios";

export const publicAxios = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export const privateAxios = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export const setApiUrl = (url: string) => {
  publicAxios.defaults.baseURL = url;
  privateAxios.defaults.baseURL = url;
};

export const setPlatformHeader = (platform: "backoffice" | "webApp" | "mobile") => {
  publicAxios.defaults.headers.common["X-Platform"] = platform;
  privateAxios.defaults.headers.common["X-Platform"] = platform;
};

let on401Callback: (() => boolean | void) | null = null;
let cookieProvider: (() => string | null) | null = null;

/**
 * Set a callback to be called when a 401 response is received.
 * If the callback returns `true`, the error will not be propagated to React Query
 * (useful when the callback performs a redirect to avoid React crash during unmount).
 */
export const setOn401Callback = (callback: () => boolean | void) => {
  on401Callback = callback;
};

export const setCookieProvider = (provider: () => string | null) => {
  cookieProvider = provider;
};

privateAxios.interceptors.request.use((config) => {
  if (cookieProvider) {
    const cookies = cookieProvider();
    if (cookies) {
      config.headers.Cookie = cookies;
    }
  }
  return config;
});

privateAxios.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      if (on401Callback) {
        const shouldBlockError = on401Callback();
        if (shouldBlockError) {
          // Return a never-resolving promise to prevent React Query from updating state
          // during redirect (which would cause a React crash)
          return new Promise(() => {});
        }
      }
    }
    return Promise.reject(error);
  },
);
